import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type HdriDetailsForHdriLightInspectorFragment = { __typename: 'Hdri', id: string, legacyId: number, name?: string | null, dataObject?: { __typename: 'DataObject', width?: number | null, height?: number | null, mediaType?: string | null, size?: any | null, originalFileName: string } | null };

export type GetHdriDetailsForHdriLightInspectorQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetHdriDetailsForHdriLightInspectorQuery = { __typename: 'Query', hdris: Array<{ __typename: 'Hdri', id: string, legacyId: number, name?: string | null, dataObject?: { __typename: 'DataObject', width?: number | null, height?: number | null, mediaType?: string | null, size?: any | null, originalFileName: string } | null } | null> };

export const HdriDetailsForHdriLightInspectorFragmentDoc = gql`
    fragment HDRIDetailsForHDRILightInspector on Hdri {
  id
  legacyId
  name
  dataObject {
    width
    height
    mediaType
    size
    originalFileName
  }
}
    `;
export const GetHdriDetailsForHdriLightInspectorDocument = gql`
    query getHDRIDetailsForHDRILightInspector {
  hdris(take: 9999, orderBy: [{key: name, direction: asc}]) {
    ...HDRIDetailsForHDRILightInspector
  }
}
    ${HdriDetailsForHdriLightInspectorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetHdriDetailsForHdriLightInspectorGQL extends Apollo.Query<GetHdriDetailsForHdriLightInspectorQuery, GetHdriDetailsForHdriLightInspectorQueryVariables> {
    override document = GetHdriDetailsForHdriLightInspectorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }